import React from 'react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';

var ModalTransition = function ModalTransition(props) {
  return /*#__PURE__*/React.createElement(ExitingPersistence, {
    appear: true
  }, props.children);
};

export default ModalTransition;